window.SLDS = window.SLDS || {};

window.SLDS.banner = (id) => ({
  init() {
    // Check if the banner has been dismissed in this session.
    const bannerDismissed = sessionStorage.getItem(
      `slds-banner-dismissed-${id}`,
    );

    // Check if the banner is dismissed.
    if (bannerDismissed) {
      // If dismissed, do not show the banner.
      return;
    }

    // Remove the hidden class.
    this.$root.classList.remove("js:hidden");

    // Show the banner.
    this.bannerVisible = true;
  },

  dismissBanner(id) {
    this.$root.classList.add("js:hidden");

    // Store the banner dismissal in session storage.
    sessionStorage.setItem(`slds-banner-dismissed-${id}`, "true");
  },
});
